module.exports = {
    'Site for adults only!': 'Site exclusivement réservé aux adultes!',
    'According to the French law, the permitted age is 18- Article 488 al. 1 of the Civil Code': 'Selon la Loi française, la majorité est fixée à 18 ans accomplis – Article 488 al. 1 du Code civil',
    'I confirm that I have read and accepted without reservation all the provisions contained in the ': 'Je certifie avoir lu et accepté sans réserves l’ensemble des dispositions contenues dans les ',
    'Terms and Conditions': 'Conditions Générales d’Utilisation',
    ' of this server.': ' de ce serveur.',
    'Exit': 'Sortir'
}


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/disclaimer.js